/**
 * @voltxampere/web — Preset category builtin commands (Sprint 22 C3)
 *
 * One `preset.<presetId>` command per entry in `ALL_PRESETS`
 * (`@voltxampere/presets` registry). Each preset command loads the
 * canonical fixture into `currentCircuit`, switches to the SİMÜLATÖR
 * pane, and clears the undo history (Sprint 21 C6 import behaviour
 * mirror).
 *
 * As the preset library grows in S23+ (555 timer, custom RLC
 * playgrounds), new entries automatically surface in the palette
 * without a registration step.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { ALL_PRESETS } from "@voltxampere/presets";
import { LoadCircuitCommand } from "@voltxampere/ui/canvas";

import type { Command } from "../types.js";
import { currentCircuit } from "../../store/circuit.js";
import { undoStack } from "../../store/undo-stack.js";
import { setPane } from "../../store/router.js";

export const PRESET_COMMANDS: readonly Command[] = ALL_PRESETS.map((preset) => ({
  id: `preset.${preset.id}`,
  titleKey: `command.preset.${preset.id}`,
  descriptionKey: `command.preset.${preset.id}.desc`,
  category: "preset" as const,
  execute: () => {
    const current = currentCircuit.value;
    if (current) {
      // Use LoadCircuitCommand so undo can rewind to the previous
      // circuit. Mirrors Sprint 18 preset-loader behaviour.
      const cmd = new LoadCircuitCommand(preset.circuit);
      const next = undoStack.execute(cmd, current);
      currentCircuit.value = next;
    } else {
      currentCircuit.value = preset.circuit;
    }
    setPane("simulator");
  },
}));
